module.exports = __webpack_public_path__ + "static/media/multiple-choice-timed.039323ed.svg";